import { usePathname, useSearchParams } from "next/navigation"

export const useAuthCallbackUrl = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const relative = searchParams.get("next") || (pathname.startsWith("/auth") ? "/" : pathname)

  // Absolute URL required: BetterAuth stores callbackURL when sending the
  // magic link and redirects to it after verify. In preview, verify runs on
  // `auth.preview.webscraping.app`, so a relative path would resolve against
  // the auth host instead of the originating PR subdomain.
  const origin = globalThis.window === undefined ? "" : globalThis.location.origin
  const relativePath = relative.startsWith("/") ? relative : `/${relative}`
  return `${origin}${relativePath}`
}
